import { render, staticRenderFns } from "./CreateCampaignReviewCardDetails.vue?vue&type=template&id=40b2e992&scoped=true"
import script from "./CreateCampaignReviewCardDetails.vue?vue&type=script&lang=js"
export * from "./CreateCampaignReviewCardDetails.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignReviewCardDetails.vue?vue&type=style&index=0&id=40b2e992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b2e992",
  null
  
)

export default component.exports